export default __webpack_public_path__ + "static/media/business.9ab25cda.svg";